import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import ModalWrapper from '../ModalWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollInHubSpotPaymentsInvoicesModal = ({
  handleInterstitialModalClose,
  screen,
  subscreen
}) => {
  const Body = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "300",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.acceptOnlinePayments"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      textAlign: "start",
      children: /*#__PURE__*/_jsxs(List, {
        styled: true,
        wrapChildren: true,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.bullet1"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.bullet2"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.bullet3"
        })]
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.connectPaymentProcessor"
      })
    })]
  });
  const Footer = /*#__PURE__*/_jsx(GoToProcessorPickerButton, {
    use: "primary",
    sourceApp: screen,
    openInCommerceHome: true,
    location: subscreen || 'embed-point-enroll-payments-invoices-modal',
    block: false
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: handleInterstitialModalClose,
    modalName: "invoicesEnrollInHubSpotPaymentsModal",
    Body: Body,
    Footer: Footer,
    illustrationName: "payments-button",
    modalSubTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.invoicesEnrollInHubSpotPaymentsModal.enrollInHubSpotPayments"
    }),
    paddingBlock: "1000",
    paddingInlineEnd: "1000"
  });
};
export default EnrollInHubSpotPaymentsInvoicesModal;